import { useEffect, useRef, useState } from "react";
import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { useTranslate } from "../../hooks/useTranslate";
import "./TruncatedText.css";

const TruncatedText = (props) => {
    const { children, maxLines = 2, variant = "body1" } = props;
    const { t } = useTranslate();

    const [isExpanded, setIsExpanded] = useState(false);
    const [isTruncated, setIsTruncated] = useState(false);
    const textRef = useRef(null);

    useEffect(() => {
        const el = textRef.current;
        if (!el) return;

        const lineHeight = parseFloat(getComputedStyle(el).lineHeight);
        const maxHeight = lineHeight * maxLines;

        setIsTruncated(el.scrollHeight > maxHeight);
    }, [maxLines]);

    return (
        <div className="truncated-text">
            <Typography
                ref={textRef}
                variant={variant}
                component="div"
                sx={{
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: isExpanded ? "unset" : maxLines,
                    overflow: "hidden",
                }}
            >
                {children}
            </Typography>
            {isTruncated && (
                <Button
                    className="truncated__button"
                    onClick={() => setIsExpanded((prev) => !prev)}
                >
                    {isExpanded ? t("common.readLess") : t("common.readMore")}
                </Button>
            )}
        </div>
    );
};

export default TruncatedText;
